import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formControlUse"],
  _excluded2 = ["hovered"];
import { memo } from 'react';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { HighlySensitiveDataMaskedDisplay } from '../dataSensitivity/HighlySensitiveDataMaskedDisplay';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { HIGHLY_SENSITIVE_MASKED_DISPLAY } from '../dataSensitivity/highlySensitiveMaskedDisplay';
import { getDataAttributes } from '../utils/getDataAttributes';
import useHovered from 'UIComponents/hooks/useHovered';
import { ShowHighlySensitiveValueButton } from '../dataSensitivity/ShowHighlySensitiveValueButton';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyInputHighlySensitive = props => {
  const {
      formControlUse
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  useComponentMountMetric('PropertyInputHighlySensitive');
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded2);
  if (isUngatedForDisplayOptimizedFormControl) {
    return /*#__PURE__*/_jsx(HighlySensitiveDataMaskedDisplay, {
      dataAttributes: getDataAttributes(rest)
    });
  }
  if (formControlUse === 'floating') {
    return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(rest), {
      children: HIGHLY_SENSITIVE_MASKED_DISPLAY
    }));
  }
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    display: "inline-flex",
    alignItems: "center",
    position: "relative",
    justifyContent: "center"
  }, hoveredProps, {
    children: [/*#__PURE__*/_jsx(View, {
      position: "absolute",
      children: /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(rest), {
        children: HIGHLY_SENSITIVE_MASKED_DISPLAY
      }))
    }), /*#__PURE__*/_jsx(ShowHighlySensitiveValueButton, {
      isVisible: hovered
    })]
  }));
};
export default /*#__PURE__*/memo(PropertyInputHighlySensitive);